import { css } from '@emotion/react'
import principalColors from '../../utils/colors'

const Styles = ({ colors }) => {
  const { primary } = principalColors()
  const { scales: { grayShades, yellow } } = colors

  return ({
    curveBack: css`
      background-color: ${primary}
    `,
    mainStyle: css`
      max-width: 68rem;
      margin: 0 auto;
      padding: 5rem 0;
      display: flex;
      align-items: left;
      justify-content: space-between;
      flex-direction: row;
      @media (max-width: 768px) { 
        padding: 3.75rem 1rem 5rem 1rem;
        align-items: center;
        flex-direction: column;
      }
    `,
    subMainStyle: css`
      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      max-width: 36rem;
      @media (max-width: 768px) {
        margin-top: 0;
        align-items: center;
      }
      @media (min-width: 375px) and (max-width: 400px) {
        height: 27.5rem;
      }
    `,
    logoIon: css`
      padding-right: 1rem;
      width: 10rem;
      height: 2.5rem;
      @media (max-width: 768px){
        width: 8rem;
        height: 2.125rem;
      }
    `,
    logoBroker: css`
      width: 7.125rem;
      height: 2.625rem;
      margin-left: 1.5rem;
      @media (max-width: 768px){
        width: 8rem;
        height: 2.125rem;
      }
    `,
    logosStyle: css`
      @media (max-width: 768px) { 
        display: flex;
        align-items: center;
      }
    `,
    description: css`
      color: ${grayShades[0]} !important;
      padding-top: 1.5rem;
      @media (max-width: 768px) {
        text-align: center;
        padding-bottom: 2.5rem;
      }
    `,
    title: css`
      color: ${grayShades[0]} !important;
      padding-top: 3rem;
      @media (max-width: 768px) {
        text-align: center;
        padding-top: 1.5rem;
      }
    `,
    changingText: css`
      cursor: none;
      color: ${yellow[5]}
    `
  })
}

export { Styles }
